import { Component } from '@angular/core';

@Component({
  selector: 'ca-restrictions-and-limitation-setting-group',
  templateUrl: './restrictions-and-limitation-setting-group.component.html',
  styleUrls: ['./restrictions-and-limitation-setting-group.component.scss'],
  standalone: false,
})
export class RestrictionsAndLimitationGroupComponent {
  activeTab: number = 1;
}
